import {Injectable} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpStatusCode
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpErrorInterceptorService implements HttpInterceptor {

    constructor(
        private readonly toastrService: ToastrService,
    ) {
    }

    /**
     * The intercept function intercepts HTTP requests and handles the response by calling successHandler
     * for successful responses and errorHandler for errors.
     * @param request - The request parameter is an instance of the HttpRequest class, which represents an
     * HTTP request made by the client.
     * @param {HttpHandler} next - The `next` parameter is an instance of the `HttpHandler` class. It
     * represents the next handler in the chain that will process the request.
     * @returns The intercept method is returning an Observable of type HttpEvent<unknown>.
     */
    public intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            tap((res) => {
                //console.log(res);
                this.successHandler(res)
            }),
            catchError((err: any) => {
                //console.log(err);
                this.errorHandler(err);
                throw err;
            }),
        );
    }

    /**
     * The successHandler function displays a success message using the toastrService if the HTTP response
     * status is between 200 and 299.
     * @param {HttpResponse<any> | any} httpResponse - The `httpResponse` parameter is the response object
     * returned from an HTTP request. It contains information such as the status code, headers, and body of
     * the response.
     */
    private successHandler(httpResponse: HttpResponse<any> | any) {
        // if (isDevMode() && httpResponse.status >= HttpStatusCode.Ok && httpResponse.status < 300) this.toastrService.success(`${httpResponse.body.mensaje}`, `💻 ${httpResponse.status}`, {})
    }

    /**
     * The function is an error handler for HTTP responses, displaying error messages based on the type of
     * error encountered.
     * @param {HttpErrorResponse} httpErrorResponse - The `httpErrorResponse` parameter is an object that
     * represents the error response received from an HTTP request. It contains information such as the
     * status code, status text, error message, and error details.
     * @returns the HttpErrorResponse object.
     */
    private errorHandler(httpErrorResponse: HttpErrorResponse) {
        /* The code block `if (!httpErrorResponse.error)` checks if the `error` property of the
        `httpErrorResponse` object is falsy (null, undefined, false, 0, empty string). */
        if (!httpErrorResponse.error) {
            if (!environment.production) {
                this.toastrService.error(`${httpErrorResponse.statusText}`, `💻 ${httpErrorResponse.status}`, {})
            }
            return throwError(httpErrorResponse);
        }
        /* The code block `if (httpErrorResponse.error instanceof ArrayBuffer)` checks if the `error` property
        of the `httpErrorResponse` object is an instance of the `ArrayBuffer` class. */
        if (httpErrorResponse.error instanceof ArrayBuffer) {
            let text = new TextDecoder('utf-8')
            const {details, message} = JSON.parse(text.decode(httpErrorResponse.error)).error
        }
        if (httpErrorResponse.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', httpErrorResponse.error.message, {
                timeOut: 3000,
            });
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            if ((httpErrorResponse.status >= HttpStatusCode.BadRequest) && (httpErrorResponse.status < HttpStatusCode.InternalServerError)) {
                if (!environment.production && !httpErrorResponse.url?.includes('cond-variante/byMaterial')) {
                    this.toastrService.error(`${httpErrorResponse?.error?.mensaje}`, `💻 ${httpErrorResponse.status}`, {})
                }
            }
            // if (httpErrorResponse.status >= 300 && httpErrorResponse.status < 400) this.toastrService.warning(`${httpErrorResponse.error.message}`, `💻 ${httpErrorResponse.status}`, {})
            console.error(`Backend returned code ${httpErrorResponse.status},body was: ${JSON.stringify(httpErrorResponse.error)}`);
            console.log(httpErrorResponse)
        }
        return throwError(httpErrorResponse);
    }

}
